import { Dialog, DialogContent, DialogHeader, DialogTitle } from "@/components/ui/dialog";
import { DAY_NAMES_FULL, formatDate } from "@/lib/weeklyPlanUtils";

export default function AddExtraSlotDialog({
  open,
  onOpenChange,
  extraTargetDate,
  extraName,
  setExtraName,
  extraMeal,
  setExtraMeal,
  onSubmit,
}) {
  return (
    <Dialog open={open} onOpenChange={onOpenChange}>
      <DialogContent className="max-w-sm" data-testid="add-extra-dialog">
        <DialogHeader>
          <DialogTitle style={{ fontFamily: "'Cormorant Garamond', serif" }}>Legg til ny fane</DialogTitle>
        </DialogHeader>
        <div className="space-y-3">
          <p className="text-sm text-stone-500">
            {extraTargetDate ? (
              <>Fanen blir lagt til <strong>kun for {DAY_NAMES_FULL[extraTargetDate.getDay()].toLowerCase()} {formatDate(extraTargetDate)}</strong>. Velg om den skal ligge under lunsj eller middag, og skriv inn navnet.</>
            ) : (
              <>Velg om fanen skal ligge under <strong>lunsj</strong> eller <strong>middag</strong>, og skriv inn navnet (f.eks. Tilbehør, Saus, Salat, Drikke).</>
            )}
          </p>

          <div>
            <label className="text-xs uppercase tracking-wider text-stone-400 font-semibold mb-1.5 block">Vis under</label>
            <div className="flex gap-2" data-testid="extra-meal-selector">
              {[
                { key: "lunch", label: "Lunsj" },
                { key: "dinner", label: "Middag" },
              ].map((m) => (
                <button
                  key={m.key}
                  type="button"
                  onClick={() => setExtraMeal(m.key)}
                  className={`flex-1 rounded-md px-3 py-2 text-sm font-medium transition-all border ${
                    extraMeal === m.key
                      ? "bg-navy-800 text-white border-navy-800"
                      : "bg-white text-stone-600 border-stone-200 hover:bg-stone-50"
                  }`}
                  data-testid={`extra-meal-${m.key}`}
                >
                  {m.label}
                </button>
              ))}
            </div>
          </div>

          <div>
            <label className="text-xs uppercase tracking-wider text-stone-400 font-semibold mb-1.5 block">Navn på fane</label>
            <input
              value={extraName}
              onChange={(e) => setExtraName(e.target.value)}
              onKeyDown={(e) => e.key === "Enter" && onSubmit()}
              placeholder="Maks 30 tegn"
              maxLength={30}
              className="w-full rounded-md border border-stone-200 bg-white px-3 py-2 text-sm focus:border-navy-800 focus:ring-1 focus:ring-navy-800 outline-none"
              data-testid="extra-name-input"
              autoFocus
            />
            <div className="flex flex-wrap gap-1.5 mt-2">
              {["Tilbehør", "Saus", "Salat", "Drikke", "Pasta", "Pommes fritt", "Kokte grønnsaker", "Krydder smør"].map((s) => (
                <button key={s} onClick={() => setExtraName(s)} className="text-[11px] px-2 py-0.5 bg-stone-100 hover:bg-stone-200 rounded-full text-stone-700" type="button">
                  {s}
                </button>
              ))}
            </div>
          </div>

          <button onClick={onSubmit} className="w-full rounded-md bg-navy-800 px-4 py-2.5 text-sm font-medium text-white hover:bg-navy-900" data-testid="add-extra-submit">
            Legg til under {extraMeal === "lunch" ? "lunsj" : "middag"}
          </button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
